export enum FilterOperation {
  EQUAL = "equal",
  CONTAINS = "contains",
  IN = "in",
  GTE = "gte",
  LTE = "lte",
  OR = "or",
  NOT_EQUAL = "neq",
  STARTSWITH = "startswith",
}

export enum FilterType {
  STRING = "string",
  DATE = "date",
  NUMBER = "number",
  BOOLEAN = "boolean",
}

export interface FilterCriteria {
  operation?: FilterOperation;
  value: string;
  type?: FilterType;
}

export interface SortCriteria {
  field: string;
  order: "asc" | "desc";
}

export interface PaginationCriteria {
  page: number;
  pageSize: number;
}

export interface GetAllRequest {
  filters?: Record<string, FilterCriteria>;
  sort?: SortCriteria[];
  pagination?: PaginationCriteria;
}
